export const capitalizeFirstLetter = (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();

export const capitalizeAllWords = (words) => words?.split(" ")?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase());

export const removeAccents = (string) => string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");